export var AMOUNT_OF_COLUMNS = 3;